var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tutorial-button"},_vm._l((_vm.content),function(cta,index){return _c('button',{key:cta.label,class:'btn-secondary-' + cta.color,on:{"click":function($event){return _vm.action(_vm.type, index)}}},[_vm._v("\n    "+_vm._s(cta.label)+"\n  ")])}),0)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }